import { BackednResponse } from "@shared/lib/types";
import { useQuery } from "@tanstack/react-query";
import { BriefConfigService } from "../services/briefConfigService";
import { useEffect } from "react";
import { ToastService } from "@shared/lib/services";
import { BRIEF_CONFIG_QUERY_KEY } from "@entities/brief/lib/constants";
import { IGetBriefConfigResponse } from "@shared/lib/types/briefConfig";

export function useGetBriefDeliverableConfig(briefId: string) {
  const { data, isLoading, isError, error } = useQuery<
    BackednResponse<IGetBriefConfigResponse[]>
  >({
    queryKey: BRIEF_CONFIG_QUERY_KEY(briefId),
    queryFn: () => BriefConfigService.getBriefDeliverableConfig(briefId),
    enabled: !!briefId,
  });

  const errorMessage = isError && error?.message;

  useEffect(() => {
    if (errorMessage) {
      ToastService.error(errorMessage);
    }
  }, [errorMessage]);

  return {
    config: data?.data || [],
    isFetching: isLoading,
    isError,
  };
}
